import { useEffect } from 'react';

import { hydraSchemaAnalyzer } from '@api-platform/admin';
import { PresetServerError } from 'config/requests/presets';
import { HttpError } from 'react-admin';
import { useFormContext } from 'react-hook-form';

type PresetsError = HttpError | PresetServerError | null | undefined;

const isPresetServerError = (error: NonNullable<PresetsError>): error is PresetServerError =>
  Array.isArray((error as PresetServerError).violations);

export const usePresetsErrors = (error: PresetsError) => {
  const { setError, clearErrors } = useFormContext();

  useEffect(() => {
    if (!error) {
      clearErrors();
      return;
    }

    if (isPresetServerError(error)) {
      error.violations.forEach(({ propertyPath, message }) => {
        setError(propertyPath, { type: 'custom', message });
      });
      return;
    }

    const submissionErrors = hydraSchemaAnalyzer().getSubmissionErrors(error);
    if (!submissionErrors) {
      return;
    }
    Object.entries(submissionErrors).forEach(([propertyPath, message]) => {
      setError(propertyPath, { type: 'custom', message });
    });
  }, [error]);
};
